<template>
  <div class="left-menu">
    <el-select
      v-model="projectSelected"
      v-if="projectsStore.length > 1"
      value-key="token"
      class="menu__select-project">
      <el-option
        v-for="project in projectsStore"
        :key="project.token"
        :label="`${project.departure_city} - ${project.arrival_city} (${project.num_client})`"
        :value="project">
      </el-option>
    </el-select>
    <ul class="menu">
      <template v-for="menu in menus" :key="menu.path">
        <router-link
          v-if="!menu.submenus"
          :to="menu.path"
          :index="menu.path">
          <li
            class="menu__item"
            :class="{'menu__item--active': $route.path === menu.path}">
            <font-awesome-icon :icon="menu.icon" class="menu__item__icon" />
            <span class="menu__item__text">{{ menu.name }}</span>
          </li>
        </router-link>
        <submenus
          v-else
          :menu="menu" />
      </template>
    </ul>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { useProjectStore } from '@/stores';
import Submenus from '@/components/layout/Submenus.vue';

export default {
  name: 'layoutMenu',
  components: {
    Submenus,
  },
  data() {
    return {
      isCollapse: false,
    };
  },
  computed: {
    ...mapState(useProjectStore, {
      projectSelectedStore: 'projectSelected',
      projectsStore: 'projects',
    }),
    menus() {
      const menus = [
        {
          name: this.$t('layout.menus.home'),
          path: '/',
          icon: ['fal', 'home'],
        },
        this.projects,
        {
          name: this.$t('layout.menus.contact'),
          path: '/contact',
          icon: ['fal', 'envelope'],
        },
      ];
      if (!this.projectSelected.params.disable_energy) {
        menus.splice(
          menus.length - 1,
          0,
          {
            name: this.$t('layout.menus.perks'),
            path: '/perks',
            icon: ['fal', 'file-check'],
          },
        );
      }

      return menus;
    },
    projects() {
      const logos = {
        comparator: ['fal', 'analytics'],
        declaration: ['fal', 'envelope'],
        procedures: ['fal', 'tasks'],
        addresses: ['fal', 'map-marker-alt'],
        details: ['fal', 'list-alt'],
        quote: ['fal', 'list-alt'],
        inventory: ['fal', 'clipboard-list-check'],
        invoices: ['fal', 'file-invoice'],
        meeting: ['fal', 'envelope'],
        support: ['fal', 'envelope'],
      };
      return {
        name: this.$t('layout.menus.moving'),
        path: 'project',
        icon: ['fal', 'truck-moving'],
        submenus: this.projectSelected.submenu.map((submenu) => ({
          name: this.$t(`layout.menus.${submenu}`),
          path: `/${submenu}`,
          icon: logos[submenu],
        })),
      };
    },
    projectSelected: {
      get() {
        return this.projectSelectedStore;
      },
      set(projectSelected) {
        this.setProjectSelected(projectSelected);
      },
    },
  },
  methods: {
    ...mapActions(useProjectStore, ['setProjectSelected']),
  },
};
</script>

<style lang="scss">

.left-menu {
  margin-top: 20px;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;

  .menu {
    width: 100%;
    max-width: 100%;
    list-style: none;
    position: relative;
    margin: 0;
    padding-left: 0;
    box-sizing: border-box;
    color: var(--nxt-color-primary);
    a {
      text-decoration: none;
      color: inherit;
      &:focus {
        outline: none;
      }
    }
    &__item {
      font-size: 20px;
      height: 50px;
      line-height: 45px;
      margin: 12px 0 12px 12px;
      cursor: pointer;
      white-space: nowrap;
      user-select: none;
      border-radius: 3px;
      padding: 0 10px;

      @include breakpoint(desktop) {
        margin: 12px;
      }

      &:hover {
        color: var(--nxt-color-secondary);
      }
      &--active {
        font-weight: 700;
        background-color: var(--nxt-color-white);
        box-shadow: 5px 2px 14px rgba(0, 0, 0, 0.14);
        &:hover {
          color: var(--nxt-color-primary);
        }
      }
      &__icon {
        vertical-align: middle;
        margin-right: 10px;
      }
      &__text {
        vertical-align: middle;
        text-transform: uppercase;
        font-size: 16px;
        height: 100%;
        width: 100%;
        cursor: pointer;
        white-space: nowrap;
      }
    }
    &__select-project {
      margin: 0 18px 0 12px;
      width: calc(var(--nxt-left-menu-size) - 2*12px);
      @include breakpoint(mobile) {
        display: none;
      }
    }
  }
}
</style>
